import axios from "../utils/axios";

const apiPrefix = "/api/job-board";

const updateJobBoardProfileSettings = async (data) => {
    const result = await axios.post(`${apiPrefix}/settings`, data);

    return result.data.data;
};

const findJobsJobBoard = async (filters) => {
    const result = await axios.post(`${apiPrefix}/find-jobs`, filters);

    return result.data;
};

const saveJob = async (job) => {
    const result = await axios.post(`${apiPrefix}/save-job`, job);

    return result.data;
};

const getJobs = async () => {
    const result = await axios.get(`${apiPrefix}/jobs`);

    return result.data;
};

const deleteJob = async (jobId) => {
    await axios.delete(`${apiPrefix}/${jobId}`);
};

const updateAppliedStatus = async (jobId, status) => {
    await axios.post(`${apiPrefix}/${jobId}/status`, { applied: status });
};

const hideJob = async (providerJobId) => {
    await axios.post(`${apiPrefix}/hide-job`, { provider_job_id: providerJobId });
}

const trackClickApply = async (providerJobId) => {
    await axios.post(`${apiPrefix}/click`, { provider_job_id: providerJobId });
}

const giveIndividualFeedback = async (data) => {
    const results =  await axios.post(`${apiPrefix}/feedback`, data);
    return results.data.data;
}

const deleteIndividualFeedback = async (uuid) => {
    await axios.delete(`${apiPrefix}/feedback/${uuid}`);
}

const updateFeedbackComment = async (uuid, data) => {
    await axios.put(`${apiPrefix}/feedback/${uuid}`, data);
}

const fetchJobById = async (jobId) => {
    try {
        const response = await axios.get(`${apiPrefix}/job/${jobId}`);
        return response?.data?.data ?? null
    } catch (error) {
        console.error("Error fetching job details:", error);
        return null; 
    }
};

const getRecommendedJobs = async (page) => {
    const results =  await axios.get(`${apiPrefix}/recommendations`);

    return results?.data
}

// Job Alerts Api

const saveFilters = async (data) => {
    const results =  await axios.post(`${apiPrefix}/subscriptions`, data);
    return results.data
}

const getFilters = async (data) => {
    const results =  await axios.get(`${apiPrefix}/subscriptions`, data);
    return results.data.data
}

const updateFilter = async (id, data) => {
    const results =  await axios.put(`${apiPrefix}/subscriptions/${id}`, data);
    return results.data
}

const deleteFilter = async (id) => {
    await axios.delete(`${apiPrefix}/subscriptions/${id}`);
} 

const getPersonalizedJobRecommendations = async () => {
    const results =  await axios.get(`${apiPrefix}/user-settings`);
    return results.data.data
}

const updatePersonalizedJobRecommendations = async (data) => {
    const results =  await axios.post(`${apiPrefix}/user-settings`, data);
    return results.data.data
}

const getJobSummary = async (jobId) => {
    const results =  await axios.get(`${apiPrefix}/${jobId}/get-job-summary`);
    return results.data.data
}

export default {
    updateJobBoardProfileSettings,
    findJobsJobBoard,
    saveJob,
    getJobs,
    deleteJob,
    updateAppliedStatus,
    hideJob,
    trackClickApply,
    giveIndividualFeedback,
    deleteIndividualFeedback,
    updateFeedbackComment,
    fetchJobById,
    getRecommendedJobs,
    saveFilters,
    getFilters,
    updateFilter,
    deleteFilter,
    getPersonalizedJobRecommendations,
    updatePersonalizedJobRecommendations,
    getJobSummary
};
